import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { H3 } from 'foundations-components/transitional/components/H3';
import PracticalExerciseResubmitButtonContainer from './PracticalExerciseResubmitButtonContainer';
import PracticalExerciseRetryButtonContainer from './PracticalExerciseRetryButtonContainer';
import PracticalExerciseCondensedWrapper from './PracticalExerciseCondensedWrapper';
import PracticalExerciseProgressFeedback from './PracticalExerciseProgressFeedback';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FailedPracticalExerciseCondensed = ({
  advanceToNextContent,
  isPassRequiredForCert,
  onResubmitClick,
  resubmitType,
  title,
  contentId,
  trackId,
  lessonId
}) => {
  return /*#__PURE__*/_jsx(PracticalExerciseCondensedWrapper, {
    buttons: /*#__PURE__*/_jsxs(_Fragment, {
      children: [resubmitType === 'resubmit' ? /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(PracticalExerciseResubmitButtonContainer, {
          exerciseName: title,
          onConfirm: onResubmitClick
        })
      }) : /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        children: /*#__PURE__*/_jsx(PracticalExerciseRetryButtonContainer, {
          contentId: contentId,
          lessonId: lessonId,
          trackId: trackId
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: advanceToNextContent,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.continue"
        })
      })]
    }),
    children: /*#__PURE__*/_jsxs(PracticalExerciseProgressFeedback, {
      illustrationName: "missed-goal",
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.statusTitle.failed"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.statusSubtitle.failed"
      }), !!isPassRequiredForCert && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.reminder.required"
          })
        })
      })]
    })
  });
};
export default FailedPracticalExerciseCondensed;